import React, { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { createProceeding } from '../../adapters/proceedings';
import SuccessStatus, { ErrorStatus } from '../../components/FormStatus';
import { InputField, SelectOptionField } from '../../components/Input';
import { createProceedingRequest } from '../../requests/proceedings';

export default function ScheduleProceeding() {

  const navigate = useNavigate();
  const params = useParams();
  const [ errors, setErrors ] = useState([]);
  const [ formState, setformState ] = useState({
      status: false,
      link: '',
      date: '',
      time: '',
      type: '',
      caseId: params.caseId
  })

  const handleFactInputChamge = (val, name) => {
    setErrors([]);
    formState[name] = val
    setformState(formState);
  }

  const submitForm = async() => {
    const data = formState;
    delete data.status;
    await createProceedingRequest.validate(data).then(async () => {
      try {
        await createProceeding(data).then((res) => {
          if(res.status === 200) {
            formState.status = true;
            setformState(formState);
          }
          setErrors(['Unable to schedule meeting'])
        })
      } catch (err) {
        setErrors(['Unable to schedule meeting'])
      }
    }).catch((e) => {
      setErrors(e.errors)
    })
  }

  return (
    <div className="relative">

      <div className="wrapper-2 animate__animated animate__fadeIn">
        <div className="gradient-bg relative rounded-b-lg py-12 mb-10 px-8 flex lg:items-center lg:flex-row flex-col justify-start lg:justify-between items-start gap-4">
          <div>
            <h1 className="font-fira xl:text-2xl text-xl">Schedule Meeting</h1>
            {/* <p className="text-xs lg:text-sm font-taviraj">Resolve your issues easily and risk free</p> */}
          </div>
          <button onClick={() => {
            navigate(-1);
          }} className=" border-2 border-blue-900 px-4 py-2 gap-1 flex items-start hover:text-blue-900 rounded-lg text-gray-800 font-semibold text-xs left-8">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clipRule="evenodd" />
              </svg>
            </span>

            <span>
              Back
            </span>
          </button>
        </div>

        <div className="mt-4 bg-gray-100 pb-6 rounded-lg border-2 border-gray-300">
          <div className="lg:w-1/2 w-full py-8 px-6 lg:px-8">
            <h4 className="mb-1 text-xs font-semibold text-gray-600">Fill outh the form to schedule a meeting</h4>
            <div className="mt-4">
              <div className="mb-3">
                <ErrorStatus errors={errors} />
                <SuccessStatus message="Meeting scheduled successfully" showStatus={formState.status} />
              </div>
              <form onSubmit={(e) => {
                e.preventDefault(); setErrors([]); 
                submitForm()
              }}>

                <SelectOptionField label="Select Payment Type" isRequired={true} id="payment-type" defaultValue={formState.type} onChange={(e) => {
                  handleFactInputChamge(e.target.value, 'type')
                }} options={["","Audio","Video"]} />

                <InputField
                  onChange={(e) => {
                    handleFactInputChamge(e.target.value, 'date')
                  }}
                  isRequired={true} type="date" id="md" placeholder="Date of Meeting" name="date" defaultValue={formState.date} label="Meeting Date" />

                <InputField
                  onChange={(e) => {
                    handleFactInputChamge(e.target.value, 'time')
                  }}
                  isRequired={true} type="time" id="mt" placeholder="Time of Meeting" name="time" defaultValue={formState.time} label="Meeting Time" />

                <InputField
                  onChange={(e) => {
                    handleFactInputChamge(e.target.value, 'link')
                  }}
                  isRequired={true} type="url" id="ml" placeholder="Meeting Link" name="link" defaultValue={formState.link} label="Meeting Access Link" />

                <button type="submit" className='bg-blue-800 text-white py-3 text-xs font-semibold font-fira rounded-lg hover:bg-blue-900 mt-6 w-full text-center'>Schedule Meeting</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  )
}
